module.exports = __webpack_public_path__ + "static/InTow-Connect-Console-Setup-and-User-Guide-6cc5de1ea1299b934f97a03c24a9e26f.pdf";